export default __webpack_public_path__ + "static/media/2.5e4f20bf.png";